import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_DISTRICT_POSTAL_CODES,
  FLAG_GETTING_DISTRICT_POSTAL_CODES,
  GET_DISTRICT_POSTAL_CODES,
} from '../types';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { DISTRICT_POSTAL_CODE_ENDPOINT } from '../../config/endpoints';

const flagGettingDistrictPostalCodes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DISTRICT_POSTAL_CODES,
    payload: flag,
  });

const getDistrictPostalCodes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingDistrictPostalCodes(true));
    const query = tableFilters;
    const url = `${DISTRICT_POSTAL_CODE_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const districts = await response.json();
    dispatch({
      type: GET_DISTRICT_POSTAL_CODES,
      payload: districts,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingDistrictPostalCodes(false));
  }
};

const clearDistrictPostalCodes = () => (dispatch) =>
  dispatch({
    type: CLEAR_DISTRICT_POSTAL_CODES,
  });

export { getDistrictPostalCodes, clearDistrictPostalCodes };
